/* unplugin-vue-components disabled */import { render } from "./KilaKilaFooter.vue?vue&type=template&id=731796ac&scoped=true"
import script from "./KilaKilaFooter.vue?vue&type=script&lang=js"
export * from "./KilaKilaFooter.vue?vue&type=script&lang=js"

import "./KilaKilaFooter.vue?vue&type=style&index=0&id=731796ac&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731796ac"]])

export default __exports__